/* tslint:disable */
/* eslint-disable */
/**
 * Inhouse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PaymentSummaryDto
 */
export interface PaymentSummaryDto {
    /**
     * 
     * @type {Date}
     * @memberof PaymentSummaryDto
     */
    from: Date;
    /**
     * 
     * @type {number}
     * @memberof PaymentSummaryDto
     */
    numberOfAuthorisations: number;
    /**
     * 
     * @type {number}
     * @memberof PaymentSummaryDto
     */
    numberOfRefunds: number;
    /**
     * 
     * @type {Date}
     * @memberof PaymentSummaryDto
     */
    to: Date;
    /**
     * 
     * @type {string}
     * @memberof PaymentSummaryDto
     */
    totalAuthorisedAmount: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentSummaryDto
     */
    totalCommissionAmount: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentSummaryDto
     */
    totalNetAmount: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentSummaryDto
     */
    totalPaymentFeeAmount: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentSummaryDto
     */
    totalRefundedAmount: string;
}

/**
 * Check if a given object implements the PaymentSummaryDto interface.
 */
export function instanceOfPaymentSummaryDto(value: object): value is PaymentSummaryDto {
    if (!('from' in value) || value['from'] === undefined) return false;
    if (!('numberOfAuthorisations' in value) || value['numberOfAuthorisations'] === undefined) return false;
    if (!('numberOfRefunds' in value) || value['numberOfRefunds'] === undefined) return false;
    if (!('to' in value) || value['to'] === undefined) return false;
    if (!('totalAuthorisedAmount' in value) || value['totalAuthorisedAmount'] === undefined) return false;
    if (!('totalCommissionAmount' in value) || value['totalCommissionAmount'] === undefined) return false;
    if (!('totalNetAmount' in value) || value['totalNetAmount'] === undefined) return false;
    if (!('totalPaymentFeeAmount' in value) || value['totalPaymentFeeAmount'] === undefined) return false;
    if (!('totalRefundedAmount' in value) || value['totalRefundedAmount'] === undefined) return false;
    return true;
}

export function PaymentSummaryDtoFromJSON(json: any): PaymentSummaryDto {
    return PaymentSummaryDtoFromJSONTyped(json, false);
}

export function PaymentSummaryDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaymentSummaryDto {
    if (json == null) {
        return json;
    }
    return {
        
        'from': (new Date(json['from'])),
        'numberOfAuthorisations': json['numberOfAuthorisations'],
        'numberOfRefunds': json['numberOfRefunds'],
        'to': (new Date(json['to'])),
        'totalAuthorisedAmount': json['totalAuthorisedAmount'],
        'totalCommissionAmount': json['totalCommissionAmount'],
        'totalNetAmount': json['totalNetAmount'],
        'totalPaymentFeeAmount': json['totalPaymentFeeAmount'],
        'totalRefundedAmount': json['totalRefundedAmount'],
    };
}

export function PaymentSummaryDtoToJSON(json: any): PaymentSummaryDto {
    return PaymentSummaryDtoToJSONTyped(json, false);
}

export function PaymentSummaryDtoToJSONTyped(value?: PaymentSummaryDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'from': value['from'].toISOString(),
        'numberOfAuthorisations': value['numberOfAuthorisations'],
        'numberOfRefunds': value['numberOfRefunds'],
        'to': value['to'].toISOString(),
        'totalAuthorisedAmount': value['totalAuthorisedAmount'],
        'totalCommissionAmount': value['totalCommissionAmount'],
        'totalNetAmount': value['totalNetAmount'],
        'totalPaymentFeeAmount': value['totalPaymentFeeAmount'],
        'totalRefundedAmount': value['totalRefundedAmount'],
    };
}

